import { Link } from "wouter";
import { Lock, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UpgradeCtaProps {
  message?: string;
}

export function UpgradeCta({
  message = "This feature is available on the Pro plan.",
}: UpgradeCtaProps) {
  return (
    <div className="flex flex-col items-start gap-2 p-4 rounded-lg border border-dashed border-amber-300 bg-amber-50/60 dark:bg-amber-950/20 dark:border-amber-700">
      <div className="flex items-center gap-2 text-amber-700 dark:text-amber-400">
        <Lock className="w-4 h-4 shrink-0" />
        <span className="text-sm font-medium">Pro feature</span>
      </div>
      <p className="text-sm text-muted-foreground">{message}</p>
      <Link href="/upgrade">
        <Button size="sm" variant="default" className="gap-1.5 mt-1">
          <Sparkles className="w-3.5 h-3.5" />
          Upgrade to Pro
        </Button>
      </Link>
    </div>
  );
}
